export default __webpack_public_path__ + "static/media/google_store_download_badge.33323e2d.svg";